import './BetbookSearchDialog.less';

import React from 'react';
import { DialogBody, DialogTitle, Docked } from '@/ui/dialogs/Dialog';
import i18n from '@i18n';
import SearchBox from '@/fullsearch/views/SearchBox';
import { scrollBody } from '@/common/client';

function BetbookSearchDialog() {
    function onClose() {
        scrollBody(true);
    }
    return (
        <Docked onClose={onClose}>
            <DialogTitle>
                <h2 className="betbook-search-dialog-title">{i18n('betbook.post.chooseMatch')}</h2>
            </DialogTitle>
            <DialogBody className="betbook-search-dialog-body">
                <SearchBox visible betbookActive />
            </DialogBody>
        </Docked>
    );
}

export default BetbookSearchDialog;
